'use client';

import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { MenuInfo } from './MenuInfo';
import {
  resolveIcon,
  externalProps,
  resolveHref,
  trackMenuClick,
} from './menuUtils';
import { Icon } from '@/components/Icon';
import type { EventTrackingResolved } from '@/lib/gtm/pushCmsEventTracking';
import type { MenuItem } from '@/types/menu';

interface MenuSubPanelProps {
  item: MenuItem;
  menuTracking?: EventTrackingResolved[];
  onBack: () => void;
  onClose: () => void;
}

export const MenuSubPanel = ({
  item,
  menuTracking,
  onBack,
  onClose,
}: MenuSubPanelProps) => (
  <>
    <button
      onClick={onBack}
      className="text-primary mb-4 flex items-center gap-1 text-sm font-medium"
    >
      <Icon src="/icons/svg/chevron-left.svg" size={16} />
      zurück
    </button>

    <h2 className="mb-4 text-base font-medium">{item.label}</h2>

    <div
      className={classNames(
        'lg:grid lg:gap-x-8',
        item.cta ? 'lg:grid-cols-4' : 'lg:grid-cols-3',
      )}
    >
      <ul className="[&>li]:border-card-border grid list-none gap-x-8 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-3 [&>li]:border-b sm:[&>li]:border-t sm:[&>li]:border-b-0 [&>li:last-child]:border-b-0 sm:[&>li:nth-last-child(-n+2)]:border-b lg:[&>li:nth-last-child(-n+3)]:border-b">
        {item.children.map((child) => (
          <li key={`${child.label}-${child.linkTarget}`}>
            <a
              href={resolveHref(child.linkTarget)}
              onClick={() => {
                trackMenuClick(child.label, child.tracking, menuTracking);
                onClose();
              }}
              {...externalProps(resolveHref(child.linkTarget))}
              className="hover:text-primary flex items-center gap-3 py-3 text-base font-medium transition-colors md:py-4"
            >
              {child.icon && (
                <Icon
                  src={resolveIcon(child.icon)!}
                  size={24}
                  className="shrink-0 opacity-60"
                />
              )}
              {child.label}
            </a>
          </li>
        ))}
      </ul>

      {item.cta && <MenuInfo cta={item.cta} onClose={onClose} />}
    </div>
  </>
);
